module.exports = __webpack_public_path__ + "static/media/ec.478bab4b.svg";